export const getPlatformLabel = (platform: 'tiktok' | 'instagram') => {
    return platform === 'tiktok' ? 'TikTok' : 'Instagram';
};
